import React from "react";
import Image from "next/image";
import { SimpleGrid } from "@chakra-ui/react";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import { Card } from "ui/cards";
import { LottieAnimation } from "ui/lottie";
import { integrationsCount } from "../../constants/integrations";
import card2Image from "../../../public/assets/platform-overview-content/feature-card-2.png";
import card3Image from "../../../public/assets/platform-overview-content/feature-card-3.png";
import card1Animation from "./feature-card-1.json";

export function PlatformFeatureCards() {
  return (
    <Section my="0">
      <TextTitle
        align="center"
        size="lg"
        title="One platform to bring your best customer data to every tool"
        description="Turning your existing data warehouse into a CDP gives easy, self-service data to marketers with flexibility and control for data teams. "
        maxW="4xl"
        descriptionMaxW="700px"
      />

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        gap={{ base: "big", md: "small" }}
        justifyItems="center"
        mt={{ base: "biggest", md: "huge" }}
      >
        <Card
          variant="fill"
          title="Access your data instantly"
          description="Explore and create custom audiences directly off your data warehouse, without code."
          media={<LottieAnimation ratio={1 / 1} animationData={card1Animation} />}
        />

        <Card
          variant="fill"
          title={`Sync any data to ${integrationsCount}+ tools`}
          description="Activate your data to any platform, unlock granular testing and closed-loop measurement."
          media={
            <Image
              fill
              src={card2Image}
              alt={`Data syncing from an audience titled "Loyalty members" into ${integrationsCount}+ tools.`}
              sizes="100%"
            />
          }
        />

        <Card
          variant="fill"
          title="Boost channel performance"
          description="Expand LTV, reduce wasted spend, and optimize performance across media channels."
          media={
            <Image
              fill
              src={card3Image}
              alt="Personalized customer emails shown on web and mobile screens. Floating icons indicating boosted ROAS and conversion performance from the campaigns."
              sizes="100%"
            />
          }
        />
      </SimpleGrid>
    </Section>
  );
}
